import { Tab, TabPanel, TabPanels, Tabs, TabsList } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';
import { Card, Col, Row } from 'reactstrap';
import Loading from '../../components/info/Loading';
import { SearchControls } from './parts/SearchControls';
import {
  SectionsFormConsumer,
  SectionsFormLoader,
} from './parts/SectionsFormLoader';
import { SectionsConsumer, SectionsLoader } from './parts/SectionsLoader';
import { TableCEClosingPeriod } from './parts/Table';
import { SectionStateEnum } from './types';

const sectionState: Record<SectionStateEnum, string> = {
  open: 'open',
  closed_with_pendind: 'closed_with_pendind',
  closed: 'closed',
};

export default function CEClosingPeriod() {
  const { t } = useTranslation();
  const prefix = 'ceClosingPeriod';

  const state: SectionStateEnum = 'open';

  return (
    <SectionsFormLoader fetchImmediately>
      <SectionsFormConsumer>
        {({ result }) => {
          if (!result?.success) {
            return 'Ha ocurrido un error al cargar los datos del formulario';
          }
          return (
            <SectionsLoader
              defaultQuery={{
                state,
                page: 1,
              }}
              fetchImmediately
            >
              <SectionsConsumer>
                {({ query, updateQuery }) => (
                  <Card className="p-4 mt-2 mx-3">
                    <br className="mb-4" />
                    <Row>
                      <Col md={12}>
                        <SearchControls
                          onSearch={(q) =>
                            updateQuery({
                              ...q,
                              state: query.state,
                              page: 1,
                            })
                          }
                          onClear={() =>
                            updateQuery({
                              state: query.state,
                              page: 1,
                            })
                          }
                        />
                      </Col>
                    </Row>

                    <br className="mt-4" />
                    <Tabs
                      size="md"
                      defaultTab={query.state}
                      onSelection={(s) =>
                        updateQuery({
                          ...query,
                          state: s as SectionStateEnum,
                          page: 1,
                        })
                      }
                    >
                      <TabsList>
                        <Tab id={sectionState.open}>
                          {t(`${prefix}.state.open`)}
                        </Tab>
                        <Tab id={sectionState.closed_with_pendind}>
                          {t(`${prefix}.state.closed_with_pendind`)}
                        </Tab>
                        <Tab id={sectionState.closed}>
                          {t(`${prefix}.state.closed`)}
                        </Tab>
                      </TabsList>

                      <br className="mt-4" />
                      <SectionsConsumer>
                        {({ result, loading }) => {
                          if (loading) {
                            return (
                              <div>
                                <Loading insideCard />
                              </div>
                            );
                          }
                          if (!result?.success) {
                            return 'Ha ocurrido un error al cargar las secciones';
                          }
                          return (
                            <TabPanels>
                              <TabPanel id={sectionState.open}>
                                <br className="mt-4" />
                                <TableCEClosingPeriod
                                  state={sectionState.open}
                                  isLoadingResults={loading}
                                  data={result.data.data}
                                  totalPages={result.data.total_pages}
                                  totalItems={result.data.total}
                                  currentPage={query.page}
                                  onChangePage={(page) => {
                                    updateQuery({ ...query, page });
                                  }}
                                />
                              </TabPanel>

                              <TabPanel id="closed_with_pendind">
                                <br className="mt-4" />
                                <TableCEClosingPeriod
                                  state={sectionState.closed_with_pendind}
                                  isLoadingResults={loading}
                                  data={result.data.data}
                                  totalPages={result.data.total_pages}
                                  totalItems={result.data.total}
                                  currentPage={query.page}
                                  onChangePage={(page) => {
                                    updateQuery({ ...query, page });
                                  }}
                                />
                              </TabPanel>

                              <TabPanel id="closed">
                                <br className="mt-4" />
                                <TableCEClosingPeriod
                                  state={sectionState.closed}
                                  isLoadingResults={loading}
                                  data={result.data.data}
                                  totalPages={result.data.total_pages}
                                  totalItems={result.data.total}
                                  currentPage={query.page}
                                  onChangePage={(page) => {
                                    updateQuery({ ...query, page });
                                  }}
                                />
                              </TabPanel>
                            </TabPanels>
                          );
                        }}
                      </SectionsConsumer>
                    </Tabs>
                  </Card>
                )}
              </SectionsConsumer>
            </SectionsLoader>
          );
        }}
      </SectionsFormConsumer>
    </SectionsFormLoader>
  );
}
